module.exports = __webpack_public_path__ + "img/a1 wazerya.51c5dd6d.jpg";